import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import {
  acceptEULASuccess,
  acceptEULAFailure,
  getEULAFailure,
  getEULASuccess
} from './actions';
import { EulaActionTypes } from './types';
import { acceptEULA, getEULA } from 'services/user.service';

function* handleAcceptEULA() {
  try {
    const response: AxiosResponse = yield call(acceptEULA);
    if (response) {
      yield put(acceptEULASuccess());
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(acceptEULAFailure(msg || 'Unable to accept EULA'));
  }
}

function* handleGetEULA() {
  try {
    const response: AxiosResponse = yield call(getEULA);
    if (response?.data) {
      yield put(getEULASuccess(response.data.content));
    } else {
      put(getEULAFailure('Unable to get EULA'));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(getEULAFailure(msg || 'Unable to get EULA'));
  }
}

function* watchAcceptEULA() {
  yield takeLatest(EulaActionTypes.ACCEPT_EULA_START, handleAcceptEULA);
}

function* watchGetEULA() {
  yield takeLatest(EulaActionTypes.GET_EULA_START, handleGetEULA);
}

function* sagas() {
  yield all([call(watchAcceptEULA), call(watchGetEULA)]);
}

export default sagas;
